import { Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Image from '../common/Image';
import { showProgress } from '../../redux/actions/DealershipActions';
import { ErrorToast, formateDate, searchArray, sortItemsBySelection } from '../utils/Utils';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import ZeroState from '../common/ZeroState';
import FileSeachIcon from '../../assets/FileSearchIcon';

const useStyle = makeStyles({
  certBox: {
    height: '60vh',
    overflowY: 'auto',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '10px 20px',
  },
  inputField: {
    width: '98%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
  },
  journesWrapper: {
    width: '100%',
    height: '550px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  equlaIcon: {
    fontSize: '18px',
  },

  newJourneyCard: {
    background: '#fff',
    padding: '10px',
    width: '97%',
    borderRadius: '10px',
    display: 'flex',
    gap: '15px',
    alignItems: 'center',
  },

  journeyImg: {
    height: '80px',
    width: '60px',
  },
  jouneyContent: {
    width: '100%',
  },
  jouneyTitle: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  journeyDate: {
    fontSize: '12px',
  },

  addNewJourney: {
    display: 'flex',
    gap: '15px',
    width: '95%',
  },

  checkbox: {
    width: '18px',
    height: '18px',
  },
});

export const JourneyList = ({ certInfo, setCertInfo, isEdit }) => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const [journeyList, setJourneyList] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  const [filteredVal, setFilteredVal] = useState([]);

  const selectedCertInfoEdit = useSelector((state) => state.certificateData.selectedCertInfoEdit);

  const getJourneys = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.CERT_JOURNEYS);
      setJourneyList(res || []);
      setFilteredVal(res || []);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    getJourneys();
  }, []);

  useEffect(() => {
    setFilteredVal(journeyList);
  }, [journeyList]);

  const handleSearch = (e) => {
    const searchKey = e.target.value;
    setSearchVal(searchKey);
    const filtered = searchArray(journeyList, ['title'], searchKey);
    setFilteredVal(filtered);
  };

  const getColor = (isSelected, isDisabled) => {
    if (isDisabled) {
      return '#D0D5DD';
    }
    return isSelected ? '#5925DC' : '#10182B';
  };

  // Selected list should move up in the list
  const sortedJourneys = sortItemsBySelection(certInfo.journeys, filteredVal, 'id');

  return (
    <Grid className={classes.certBox}>
      <Grid style={{ width: '98%' }}>
        <input placeholder="Search journey" className={classes.inputField} value={searchVal} onChange={handleSearch} />
      </Grid>
      {sortedJourneys?.length > 0 ? (
        <Grid className={classes.journesWrapper}>
          {sortedJourneys.map((j) => (
            <Grid className={classes.newJourneyCard} key={j.id}>
              <p className={classes.equlaIcon}>
                <input
                  type="checkbox"
                  className={classes.checkbox}
                  onClick={() => {
                    if (selectedCertInfoEdit?.editWarning && isEdit) {
                      ErrorToast(selectedCertInfoEdit.editWarning);
                    } else if (j.disabled) {
                      ErrorToast(j.message);
                    } else {
                      setCertInfo((prev) => {
                        const updatedJourneys = prev.journeys.includes(j.id)
                          ? prev.journeys.filter((journeyId) => journeyId !== j.id)
                          : [...prev.journeys, j.id];
                        return {
                          ...prev,
                          journeys: updatedJourneys,
                        };
                      });
                    }
                  }}
                  checked={certInfo.journeys.includes(j.id)}
                  style={{
                    color: getColor(certInfo.journeys.includes(j.id), j.disabled),
                    opacity: j.disabled ? '0.4' : '1',
                  }}
                />
              </p>
              <Grid className={classes.addNewJourney}>
                <Image className={classes.journeyImg} src={j.thumbnail || ''} alt="Journey Pic" />
                <Grid className={classes.jouneyContent}>
                  <Grid className={classes.jouneyTitle} style={{ opacity: j.disabled ? '0.4' : '1' }}>
                    <Typography> {j.title} </Typography>
                  </Grid>
                  <Typography variant="p" className={classes.journeyDate} style={{ opacity: j.disabled ? '0.4' : '1' }}>
                    {formateDate(j.publishDate)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid className={classes.journesWrapper}>
          <ZeroState
            Icon={FileSeachIcon}
            text="No journey found. Try searching for something else."
            style={{ paddingBottom: '100px', paddingTop: '30px' }}
            cardWidth="100%"
          />
        </Grid>
      )}
    </Grid>
  );
};
